<template>
  <div class="users f-c-b f-d-c w-100 h-100 p-4 pb-22 o-f-a">
    <div class="addNewUser addNewSession f-s-s f-d-c w-100 h-90 p-4">
      <div class="return w-100 f-c-e mb-4">
        <div class="f-c-s returnBtn" @click="returnFunc()">
          <!-- <div class="arrow f-c-c ml-1">&lt;</div> -->
          <div class="returnText f-c-c">برگشت</div>
        </div>
      </div>
      <div class="progressSection f-c-b w-100 mb-4">
        <div class="item active f-c-s f-d-c">
          <div class="textSec f-c-s w-100 mb-1">
            <div class="text f-c-c">مرحله</div>
            <div class="stepNo f-c-c">1</div>
          </div>
          <div class="progressLine f-c-c w-100"></div>
        </div>
        <div class="item active f-c-s f-d-c">
          <div class="textSec f-c-s w-100 mb-1">
            <div class="text f-c-c">مرحله</div>
            <div class="stepNo f-c-c">2</div>
          </div>
          <div class="progressLine f-c-c w-100"></div>
        </div>
        <div class="item f-c-s f-d-c">
          <div class="textSec f-c-s w-100 mb-1">
            <div class="text f-c-c">مرحله</div>
            <div class="stepNo f-c-c">3</div>
          </div>
          <div class="progressLine f-c-c w-100"></div>
        </div>
      </div>
      <div class="title f-c-s w-100 pt-3 mb-4">
        <b-img
          class="title-icon ml-2"
          :src="require(`@/assets/images/gap/folder.svg`)"
        ></b-img>
        <div class="title-text f-c-c">افزودن جلسه جدید</div>
      </div>
      <div
        class="addUserBox addUserBoxStep2 f-c-s f-d-c w-100 h-100"
        style="border-top: 1px solid #125488; border-radius: 10px"
      >
        <!-- <div class="title f-c-s w-100 mb-2">انتخاب کاربر</div> -->
        <!-- <div class="search-addUser f-c-b w-100 mb-2">
          <div class="search f-c-c">
            <b-img
              :src="require(`@/assets/images/gap/search-icon-gray.svg`)"
            ></b-img>
            <input v-model="searchUser" type="text" placeholder="جستجو" />
          </div>
          <div @click.prevent="addNewUserFunc()" class="addUser f-c-c">
            <span class="plus ml-2">+</span>
            <div class="text f-c-c">افزودن کاربر</div>
          </div>
        </div> -->
        <div class="f-c-e search-addUser w-100 mb-3">
          <div class="search f-c-c">
            <input
              v-if="isSearchSansActive"
              :class="[isSearchSansActive ? 'searchUserInputActive' : '']"
              v-model="searchUser"
              type="text"
              placeholder="جستجو"
            />
            <b-img
              :class="[isSearchSansActive ? 'imgActive' : '']"
              :src="require(`@/assets/images/gap/search-icon.svg`)"
              @click="searchSansIconFunc()"
            ></b-img>
          </div>
          <div
            v-if="user.permissions.edit_session_add_sans"
            @click.prevent="addNewUserFunc()"
            class="addUser f-c-c"
          >
            <span class="plus ml-2">+</span>
            <div class="text f-c-c">مورد جدید</div>
          </div>
        </div>
        <div class="userTable userTablestep2 f-c-s f-d-c w-100 mb-3">
          <div class="header f-c-s w-100">
            <div class="headerItem f-c-s"></div>
            <div class="headerItem f-c-s w-25">نام</div>
            <div class="headerItem f-c-s">موبایل</div>
            <!-- <div class="headerItem f-c-s">ایمیل</div> -->
            <div class="headerItem f-c-s w-20">نقش</div>
            <div class="headerItem f-c-c w-30">عملیات</div>
          </div>
          <div v-if="users.length" class="tableContent f-c-s f-d-c w-100">
            <div v-for="(v, i) in users" :key="i" class="tableRow f-c-s w-100">
              <div class="tableItem f-c-c">{{ i + 1 }}</div>
              <div class="tableItem f-c-s w-25">
                <div
                  class="f-c-s w-90"
                  :title="v.first_name + ' ' + v.last_name"
                  style="
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  "
                >
                  {{ v ? v.first_name + " " + v.last_name : "-" }}
                </div>
              </div>
              <div class="tableItem f-c-s">{{ v.mobile ? v.mobile : "-" }}</div>
              <!-- <div class="tableItem f-c-s">
                <div
                  class="f-c-s w-90"
                  :title="v.email"
                  style="
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  "
                >
                  {{ v.email ? v.email : "-" }}
                </div>
              </div> -->
              <div class="tableItem f-c-s w-20">
                {{
                  allRole.information
                    ? allRole.information.filter((word) => word.id == v.role)[0]
                        .title
                    : "-"
                }}
              </div>
              <!-- <div class="tableItem f-c-c">
                <b-img
                  @click.prevent="editUserFunc(v, i)"
                  class="ml-2"
                  :src="require(`@/assets/images/gap/edit-icon.svg`)"
                ></b-img>
                <b-img
                  @click.prevent="deleteUserFunc(v, i)"
                  :src="require(`@/assets/images/gap/delete-icon.svg`)"
                ></b-img>
              </div> -->
              <div class="tableItem f-c-sa w-30">
                <div class="editBtn f-c-c" @click.prevent="editUserFunc(v)">
                  ویرایش
                </div>
                <div class="deleteBtn f-c-c" @click.prevent="deleteUserFunc(v)">
                  حذف
                </div>
              </div>
            </div>
          </div>
          <div v-else class="tableContent emptyTable f-c-c w-100 h-100">
            کاربری وجود ندارد.
          </div>
        </div>
        <div v-if="users.length" class="mobileUserTable f-c-s f-d-c w-100 mb-3">
          <div
            v-for="(v, i) in users"
            :key="i"
            class="tableItem f-c-s f-d-c w-100 mb-3"
          >
            <div class="up f-c-b w-100 mb-3">
              <div class="right f-s-s f-d-c">
                <div class="labelItem f-c-c mb-2">نام :</div>
                <div class="labelItem f-c-c mb-2">موبایل :</div>
                <!-- <div class="labelItem f-c-c mb-2">ایمیل :</div> -->
                <div class="labelItem f-c-c">نقش :</div>
              </div>
              <div class="left f-e-e f-d-c">
                <div class="answerItem f-c-e mb-2">
                  {{ v ? v.first_name + " " + v.last_name : "-" }}
                </div>
                <div class="answerItem f-c-e mb-2">
                  {{ v.mobile }}
                </div>
                <!-- <div class="answerItem f-c-e mb-2">
                    {{ v.email ? v.email : "-" }}
                </div> -->
                <div class="answerItem f-c-e">
                  {{
                    allRole.information
                      ? allRole.information.filter(
                          (word) => word.id == v.role
                        )[0].title
                      : ""
                  }}
                </div>
              </div>
            </div>
            <div class="down f-c-b w-100">
              <div class="edit f-c-c" @click.prevent="editUserFunc(v)">
                <b-img
                  :src="require(`@/assets/images/mobile/edit-pen.svg`)"
                ></b-img>
              </div>
              <div class="delete f-c-c" @click.prevent="deleteUserFunc(v)">
                <b-img
                  :src="require(`@/assets/images/mobile/delete-x.svg`)"
                ></b-img>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          class="mobileUserTable tableContent emptyTable f-c-c w-100 h-100 mb-3"
        >
          کاربری وجود ندارد.
        </div>
        <div class="guest f-c-s w-100 mb-4">
          <!-- <input type="checkbox" id="b1" class="visfire" v-model="guest" /> -->
          <label for="b1" class="ml-2">امکان ورود به صورت مهمان</label>
          <select class="sessionGroup" v-model="guest">
            <option v-for="(v, i) in guestList" :key="i" :value="v">
              {{ v.title }}
            </option>
          </select>
        </div>
        <div
          class="saveStepTwoBtn f-c-c w-25"
          @click.prevent="saveSteptwoFunc()"
        >
          ادامه
        </div>
      </div>
    </div>
    <div class="gapMaterial f-c-c w-100">
      <div class="text blueText f-c-c">
        کلیه حقوق مادی و معنوی متعلق به دانشگاه آزاد اسلامی واحد الکترونیکی می
        باشد.
      </div>
    </div>
    <b-modal
      id="edit-modal"
      title="ویرایش"
      button-size="sm"
      :hide-footer="footer"
      ref="edit-modal"
    >
      <template class="content f_s_s f-d-c w-100">
        <div class="row f-c-c w-100 mb-3">
          <div class="label f-c-s">نام</div>
          <input v-model="editUser.name" type="text" />
        </div>
        <div class="row f-c-c w-100 mb-3">
          <div class="label f-c-s">نام خانوادگی</div>
          <input v-model="editUser.family" type="text" />
        </div>
        <div class="row f-c-c w-100 mb-3">
          <div class="label f-c-s">موبایل</div>
          <input v-model="editUser.mobile" type="number" />
        </div>
        <!-- <div class="row f-c-c w-100 mb-3">
          <div class="label f-c-s">ایمیل</div>
          <input v-model="editUser.email" type="email" />
        </div> -->
        <div class="row f-c-c w-100 mb-4">
          <div class="label f-c-s">نقش</div>
          <select class="gender" v-model="editUser.role">
            <option
              v-for="(v, i) in allRole.information"
              :key="i"
              :value="v.id"
            >
              {{ v.title }}
            </option>
          </select>
        </div>
        <div class="btnSec w-100 f-c-c">
          <div class="finalbtn f-c-c" @click="endEditUserFunc()">ذخیره</div>
        </div>
      </template>
    </b-modal>
    <DeleteConfirm v-if="isDelete" message="از حذف کاربر مطمئن هستید ؟" />
  </div>
</template>
<script>
import DeleteConfirm from "@/components/DelConfirmModal";
import { mapState, mapActions } from "vuex";
import { EventBus } from "@/assistant/EventBus";
export default {
  name: "AddNewSission2",
  data() {
    return {
      footer: true,
      searchUser: "",
      isDelete: false,
      isEdit: false,
      guest: {
        id: 1,
        value: "by_host_permission",
        status: true,
        title: "با اجازه مدیر جلسه",
      },
      userDeleted: {},
      userDeletedId: null,
      userEditedId: null,
      isSearchSansActive: false,
      userEdited: {},
      editUser: {
        name: "",
        family: "",
        mobile: "",
        email: "",
        role: "",
      },
      users: [],
      guestList: [
        { id: 0, value: "not_allowed", status: false, title: "ندارد" },
        {
          id: 1,
          value: "by_host_permission",
          status: true,
          title: "با اجازه مدیر جلسه",
        },
        {
          id: 2,
          value: "no_permission",
          status: true,
          title: "بدون نیاز به اجازه مدیر جلسه",
        },
      ],
    };
  },
  created() {
    this.getAllRoleFunction({
      user_id: this.user.user_id,
    });
    EventBus.$on("deleteItem", (status) => {
      this.isDelete = false;
      if (status) {
        let users = this.users.splice(this.userDeletedId, 1);

        this.setSessionStep2DataFunction({
          users: users,
          guest: this.guest,
        });
      }
    });
  },
  computed: {
    ...mapState({
      user: (state) => state.gap.user,
      sessionStep2Data: (state) => state.gap.sessionStep2Data,
      allRole: (state) => state.gap.allRole,
    }),
  },
  components: {
    DeleteConfirm,
  },
  methods: {
    ...mapActions("gap", [
      "setSessionStep2DataFunction",
      "getAllRoleFunction",
      "setAppTitleFunction",
    ]),
    searchSansIconFunc() {
      this.isSearchSansActive = !this.isSearchSansActive;
      setTimeout(() => {
        if (this.isSearchSansActive) {
          document.querySelector(".searchUserInputActive").focus();
        }
      }, 200);
    },
    addNewUserFunc() {
      // this.setSessionStep2DataFunction({})
      this.setAppTitleFunction("افزودن کاربر");
      this.$router.push({ name: "addNewUser" });
    },
    endEditUserFunc() {
      this.users[this.userEditedId].first_name = this.editUser.name;
      this.users[this.userEditedId].last_name = this.editUser.family;
      this.users[this.userEditedId].mobile = this.editUser.mobile;
      // this.users[this.userEditedId].email = this.editUser.email;
      this.users[this.userEditedId].role = this.editUser.role;
      this.setSessionStep2DataFunction({
        users: this.users,
        guest: this.guest,
      });
      this.$refs["edit-modal"].hide();
    },
    returnFunc() {
      this.setSessionStep2DataFunction({
        users: this.sessionStep2Data.users,
        guest: this.guest,
      });
      this.$router.push({ name: "addNewSission1" });
    },
    editUserFunc(v, i) {
      this.isEdit = true;
      this.userEdited = v;
      this.userEditedId = i;
      this.editUser.name = v.first_name;
      this.editUser.family = v.last_name;
      this.editUser.mobile = v.mobile;
      // this.editUser.email = v.email;
      this.editUser.role = v.role;
      this.$refs["edit-modal"].show();
    },
    deleteUserFunc(v, i) {
      this.isDelete = true;
      this.userDeleted = v;
      this.userDeletedId = i;
    },
    saveSteptwoFunc() {
      this.setSessionStep2DataFunction({
        users: this.users,
        guest: this.guest,
      });
      this.$router.push({ name: "addNewSission3" });
    },
  },
  watch: {
    guest(n) {
      this.setSessionStep2DataFunction({
        users: this.sessionStep2Data.users,
        guest: n,
      });
    },
    searchUser(n) {
      let searchArray = this.sessionStep2Data.users.filter((ticket) => {
        return (
          ticket.first_name.toLowerCase().includes(n) ||
          ticket.last_name.toLowerCase().includes(n) ||
          ticket.mobile.toLowerCase().includes(n) ||
          this.allRole.information
            .filter((word) => word.id == ticket.role)[0]
            .title.toLowerCase()
            .includes(n)
        );
      });
      this.users = searchArray;
    },
  },
  mounted() {
    this.users = this.sessionStep2Data.users;
    if (this.sessionStep2Data.guest) {
      this.guest = this.sessionStep2Data.guest;
    }
  },
};
</script>